import request from "@/utils/request";

export function searchUsers(params) {
    return request({
        url: "/api/admin/users",
        method: "get",
        params: params
    });
}

export function addUser(params) {
    return request({
        url: "/api/admin/add-user",
        method: "post",
        data: params
    });
}

export function editUser(params) {
    return request({
        url: "/api/admin/edit-user",
        method: "post",
        data: params
    });
}

export function deleteUsers(params) {
    return request({
        url: "/api/admin/delete-user",
        method: "post",
        data: params
    });
}

export function showuserdata(param) {
    return request({
        url: "/api/admin/show-user",
        method: "post",
        params: param,
    });
}

